import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MaskedLine, Reveal, SectionTag } from "@/components/Reveal";
import MediaSlot from "@/components/MediaSlot";
import { EXPERIENCES } from "@/data";

const Experiences = () => (
  <motion.main
    initial={{ opacity: 0, y: 24 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -24 }}
    transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
    className="pt-28"
    data-testid="experiences-page"
  >
    <header className="px-6 md:px-12">
      <SectionTag no="03" label="EXPERIENCES" />
      <h1 className="mt-8 font-display text-5xl font-black uppercase leading-[0.9] tracking-tighter sm:text-6xl md:text-8xl" data-testid="experiences-title">
        <MaskedLine delay={0.1}><span>EVERY EXPERIENCE</span></MaskedLine>
        <MaskedLine delay={0.25}><span>BECAME <span className="text-burgundy">A CHAPTER.</span></span></MaskedLine>
      </h1>
      <Reveal delay={0.3}>
        <p className="mt-8 max-w-xl font-serif text-xl italic leading-relaxed text-ash md:text-2xl">
          Bukan sekadar daftar organisasi. Ini adalah tempat di mana saya belajar menjadi versi diri saya yang sekarang.
        </p>
      </Reveal>
    </header>

    <section className="px-6 py-20 md:px-12" data-testid="experience-explorer">
      {EXPERIENCES.map((exp, i) => (
        <Reveal key={exp.slug} delay={0.03}>
          <Link
            to={`/experiences/${exp.slug}`}
            data-testid={`experience-link-${exp.slug}`}
            data-cursor="OPEN"
            className={`group grid items-start gap-6 border-t border-ink/10 py-10 transition-colors duration-300 hover:bg-cream md:grid-cols-12 md:gap-10 md:py-14 ${
              i === EXPERIENCES.length - 1 ? "border-b" : ""
            }`}
          >
            <span className="font-display text-sm text-burgundy md:col-span-1">{exp.no}</span>
            <div className="md:col-span-3">
              <MediaSlot
                src={exp.images.find((m) => m.src)?.src}
                slot={`${exp.slug.toUpperCase()}_COVER`}
                ratio="aspect-[4/3]"
                className="border border-ink/10 transition-transform duration-500 group-hover:-rotate-1 group-hover:scale-[1.02]"
              />
            </div>
            <div className="md:col-span-7">
              {exp.featured && (
                <span className="mb-3 inline-block bg-ember px-2 py-1 font-display text-[9px] font-black uppercase tracking-[0.25em] text-ink">
                  Key chapter
                </span>
              )}
              <h2 className="font-display text-3xl font-black uppercase tracking-tight transition-transform duration-300 group-hover:translate-x-2 md:text-5xl">
                {exp.title}
              </h2>
              <p className="mt-2 font-display text-xs font-bold uppercase tracking-[0.25em] text-burgundy">
                {exp.role} {exp.year ? `— ${exp.year}` : ""}
              </p>
              <p className="mt-4 max-w-xl font-serif text-lg italic leading-relaxed text-ash md:text-xl">"{exp.hook}"</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {exp.tags.map((t) => (
                  <span key={t} className="border border-ink/20 px-3 py-1 font-display text-[9px] font-bold uppercase tracking-[0.2em] text-ink/60">
                    {t}
                  </span>
                ))}
              </div>
            </div>
            <ArrowUpRight className="hidden h-8 w-8 self-center text-burgundy opacity-0 transition-opacity group-hover:opacity-100 md:col-span-1 md:block" />
          </Link>
        </Reveal>
      ))}
    </section>
  </motion.main>
);

export default Experiences;
